export const isWorkspaceSelectable = workspace => {
  if (!workspace) return false;

  return (
    workspace.authorization?.projection_status === "ready" &&
    Array.isArray(workspace.authorization.permissions) &&
    workspace.authorization.permissions.includes("workspace:read")
  );
};
